import { AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import { AHeaderProps } from '../../atoms/AHeader/AHeader.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';

export enum MTextBlockInteractiveAlignment {
  Left = 'Left',
  Center = 'Center',
}

export interface MTextBlockInteractiveProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MTextBlockInteractiveAlignment;
  eyebrowText?: string;
  eyebrowVariant?: AEyebrowProps['variant'];
  headerText?: string;
  headerSize?: AHeaderProps['size'];
  headerElement?: AHeaderProps['element'];
  bodyText?: string;
  bodySize?: ABodyProps['size'];
  bodyColor?: ABodyProps['color'];
  className?: string;
}
